import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFileSignature, faPartyHorn } from '@fortawesome/pro-solid-svg-icons';
import { Celebration } from '../model/celebration.type';

const CELEBRATION_ICONS: Record<string, IconProp> = {
  contract: faFileSignature,
};

const DEFAULT_CELEBRATION_ICON: IconProp = faPartyHorn;

export function getCelebrationIcon(icon: string | null | undefined): IconProp {
  return (icon && CELEBRATION_ICONS[icon]) || DEFAULT_CELEBRATION_ICON;
}

export function isCelebrationExpired(celebration: Celebration): boolean {
  return new Date(celebration.expiresOn).getTime() <= Date.now();
}
